module.exports = __webpack_public_path__ + "static/img/06.ae81e2f5.png";